<template>
  <StatisticsHeader>
    <StatisticsPanel :load="load" v-slot="{ data }">
      <ClientsStats :data="data" />
    </StatisticsPanel>
  </StatisticsHeader>
</template>

<script>
import StatisticsHeader from "@/statistics/components/StatisticsHeader.vue";
import StatisticsPanel from "@/statistics/components/StatisticsPanel.vue";
import ClientsStats from "@/statistics/components/stats/ClientsStats.vue";
import {StatisticsController} from "@/statistics/controllers/StatisticsController";

export default {
  name: 'StatisticsClientsView',
  components: {StatisticsHeader, StatisticsPanel, ClientsStats},
  methods: {
    load: urlParams => StatisticsController.getClients(urlParams),
  },
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

h1
  color: THEME_COLOR_PRIMARY
  span
    color: THEME_COLOR_PRIMARY_FADDED
</style>
